export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  PROFILE: '/auth/profile',
  CHANGE_PASSWORD: '/auth/change-password',

  // Medicamentos
  MEDICAMENTOS: '/medicamentos',
  MEDICAMENTOS_CREATE: '/medicamentos/create',
  MEDICAMENTOS_CREATE_ONE_TO_ONE: '/medicamentos/create-one-to-one',
  MEDICAMENTOS_STOCK_CRITICO: '/medicamentos/stock-critico',
  MEDICAMENTOS_VALIDAR_CUMS: '/medicamentos/validar-cums',

  // Dispensaciones
  DISPENSACIONES: '/dispensings',
  DISPENSACIONES_CREATE: '/dispensings/create',
  DISPENSACIONES_DETAIL: '/dispensings/getdispensing',
  DISPENSACIONES_UPDATE: '/dispensings/update',
  DISPENSACIONES_PDF: (id: string) => `/dispensings/pdf/${id}`,
  DISPENSACIONES_PDF_PENDIENTES: (id: string) => `/dispensings/pdf-pendientes/${id}`,
  DISPENSACIONES_PENDIENTES_MEDICAMENTOS: '/dispensings/get-medicamentos-pendientes',
  DISPENSACIONES_ENTREGADOS_MEDICAMENTOS: '/dispensings/get-medicamentos-entregados',
  DISPENSACIONES_PENDIENTES_MEDICAMENTOS_POINT: '/dispensings/get-medicamentos-pendientes-point',
  DISPENSACIONES_ENTREGADOS_MEDICAMENTOS_POINT: '/dispensings/get-medicamentos-entregados-point',
  DISPENSACIONES_SAVE_ENTREGA_PENDIENTE: '/dispensings/saveentregapendiente',
  FORMULAS_PDF_UPLOAD: '/formulaspdf/upload',
  FORMULAS_PDF_DOCUMENTOS: (idDispensacion: string) => `/formulaspdf/documentos/${idDispensacion}`,
  FORMULAS_PDF_DESCARGAR: (id: string | number) => `/formulaspdf/descargar/${id}`,
  FORMULAS_PDF_DELETE: (idDocumento: string | number) => `/formulaspdf/documentos/${idDocumento}`,

  // Usuarios
  USUARIOS: '/usuarios',
  USUARIOS_RESET_PASSWORD: (id: string) => `/usuarios/${id}/reset-password`,

  // Pacientes
  PACIENTES_BUSCAR: '/pacientes/datospaciente',
  PACIENTES_SAVE: '/pacientes/savepaciente',
  PACIENTES_ALL: '/pacientes/datospacienteall',
  PACIENTES_DISPENSACIONES: '/pacientes/getdispensaciones',

  // Genericos
  GENERICOS_TIPOS_DOC: '/genericos/tipos-doc-dian',
  GENERICOS_TIPOS_ORGA: '/genericos/tipos-orga-dian',
  GENERICOS_DEFINI_IVA: '/genericos/regi-dian',
  GENERICOS_RESPONSA_DIAN: '/genericos/resp-dian',
  GENERICOS_ESPECIALIDADES: '/genericos/especialidades',
  GENERICOS_BODEGAS: '/genericos/bodegas',
  GENERICOS_DIAGNOSTICOS: '/genericos/diagnosticos',
  GENERICOS_LABORATORIOS: '/genericos/laboratorios',
  GENERICOS_FORMAS_FARMACEUTICAS: '/genericos/formas-farmaceuticas',
  GENERICOS_UNIDADES_MEDIDAS_MED: '/genericos/unidadesmedidasmed',
  GENERICOS_VIAS_ADMINISTRACION: '/genericos/vias-administracion',
  GENERICOS_DEPARTAMENTOS: '/genericos/departamentos',
  GENERICOS_MUNICIPIOS: '/genericos/municipios',
  GENERICOS_TIPOS_IDENTIFICACIONES: '/genericos/tipos-identificaciones',
  GENERICOS_REGIMENES_SALUD: '/genericos/regimenes-de-salud',
  GENERICOS_PARENTESCOS: '/genericos/parentescos',
  GENERICOS_POBLACIONES_CLAVE: '/genericos/poblaciones-clave',
  GENERICOS_GRUPOS_ETNICOS: '/genericos/grupos-etnicos',
  GENERICOS_ESTADOS_CIVILES: '/genericos/estados-civiles',
  GENERICOS_ENTIDADES: '/genericos/entidades',
  GENERICOS_CATEGORIA_CONTRIBUTIVO: '/genericos/categoriacontributivo',

  // Bodegas (CRUD)
  BODEGAS: '/bodegas',
  BODEGAS_VENCIMIENTOS: '/bodegas/vencimientos',

  // Inventario
  INVENTARIO: '/inventario',
  INVENTARIO_CARGA_INICIAL: '/inventario/carga-inicial',
  INVENTARIO_MEDICAMENTOS_BODEGA: '/inventario/medicamentos-bodega',
  INVENTARIO_BODEGA: '/inventario/inventario-bodega',
  INVENTARIO_MAESTROS_LOTES: '/inventario/maestros-lotes',
  INVENTARIO_UPDATE_LOTE: '/inventario/update-lote',

  // Laboratorios
  LABORATORIOS: '/laboratorios',
  LABORATORIOS_FUZZY: '/genericos/laboratorios/fuzzy-search',

  // Medicamentos Vigentes
  MEDICAMENTOS_VIGENTES: '/medicamentos-vigentes',
  MEDICAMENTOS_VIGENTES_UPLOAD: '/medicamentos-vigentes/upload',
  MEDICAMENTOS_VIGENTES_CLEAR: '/medicamentos-vigentes/clear',

  // Requisiciones
  REQUISICIONES: '/requisiciones',
  REQUISICIONES_CREATE: '/requisiciones/create',
  REQUISICIONES_CREATE_BORRADOR: '/requisiciones/createBorrador',
  REQUISICIONES_ANULAR: '/requisiciones/anular',
  REQUISICIONES_APROBAR: '/requisiciones/aprobar',
  REQUISICIONES_RECHAZAR: '/requisiciones/rechazar',
  REQUISICIONES_DETALLE: `/requisiciones/detalle`,
  REQUISICIONES_PRINACTIVOS: `/requisiciones/prinactivos`,
  REQUISICIONES_CREAPRINCIPIO: '/requisiciones/creaprincipio',

  // Cotizaciones
  COTIZACIONES: '/cotizaciones',
  COTIZACIONES_LIST: '/cotizaciones/list',
  COTIZACIONES_DETALLE: '/cotizaciones/detalle',


  // Proveedores
  PROVEEDORES: '/proveedores',
  PROVEEDORES_SEARCH: '/proveedores/search',
  PROVEEDORES_SAVE: '/proveedores/save',
  PROVEEDORES_DELETE: '/proveedores/delete',

  // Clientes
  CLIENTES_SAVE: '/clientes/savecliente',
  CLIENTES_LIST: '/clientes/allclientes',

  // Reportes
  REPORTES_INVENTARIO: '/reportes/inventario',
  REPORTES_VENCIMIENTOS: '/reportes/vencimientos',
  REPORTES_PT030: '/reportes/pt030',

  // Health
  HEALTH: '/health'
};
